const KEY = "sentry.holdSolve";

/** Whether this browser was last left holding the re-solve. Storage can be blocked, so it is only a convenience. */
export function readHold(): boolean {
  try { return localStorage.getItem(KEY) === "1"; } catch { return false; }
}
export function writeHold(on: boolean): void {
  try { localStorage.setItem(KEY, on ? "1" : "0"); } catch { /* the choice just will not be remembered */ }
}

/**
 * Hold the re-solve while making many changes to a draft.
 *
 * Reassigning work normally saves a requirement and re-solves the whole draft
 * straight away. For a long run of moves that is a wait after every one of them.
 * Holding keeps each move and its requirement, and leaves the solve until
 * "Solve now". Nothing is lost by holding; the draft just has not been checked
 * against the optimizer, so a conflict between moves only shows up at the solve.
 */
export function HoldSolve({ hold, waiting, solving, onToggle, onSolve }: {
  hold: boolean;
  /** Moves made while holding, since the last solve in this browser session. */
  waiting: number;
  solving: boolean;
  onToggle: (on: boolean) => void;
  onSolve: () => void;
}) {
  const show = hold || waiting > 0;
  return (
    <div className="hold-solve">
      <label className="hold-solve-toggle">
        <input id="hold-resolve" type="checkbox" checked={hold} onChange={(e) => onToggle(e.target.checked)} />
        Hold re-solving while I make changes
      </label>
      {show && (
        <>
          <span className="muted" style={{ fontSize: 12 }}>
            {waiting > 0
              ? `${waiting} ${waiting === 1 ? "change" : "changes"} saved, not solved yet.`
              : "Moves are saved as you make them. Nothing is re-solved until you click."}
          </span>
          <button className="btn on" disabled={solving} onClick={onSolve}>Solve now</button>
        </>
      )}
    </div>
  );
}
